import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "accessValue",
    standalone: false,
})
export class AccessValuePipe implements PipeTransform {
    transform(obj: any, path: string): any {
        if (!path || !obj) return "";
        if (!path.includes(".")) return obj[path];
        return path.split(".").reduce((current, key) => (current ? current[key] : undefined), obj);
    }
}
